"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProcessSearchValue = exports.HandleSetter = exports.HandleChange = exports.GetTestIds = exports.GetTabId = exports.GetIndexFromTab = exports.CustomTabPanel = exports.ComponentTabStyles = exports.A11yProps = void 0;
var ScrollMethods = _interopRequireWildcard(require("../../utils/scroll"));
var TabsMethods = _interopRequireWildcard(require("./Tabs"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _array = require("../../utils/type-checks/array");
var _function = require("../../utils/type-checks/function");
var _number = require("../../utils/type-checks/number");
var _string = require("../../utils/type-checks/string");
var _reactRouterDom = require("react-router-dom");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  A11yProps = (number, tabId, instanceString) => {
    let a11yInstanceString = (0, _string.isStringOfLength)(instanceString) ? instanceString : "";
    return (0, _string.isStringOfLength)(tabId) && (0, _number.isNumber)(number) ? {
      "aria-controls": `id_tabpanel-${a11yInstanceString}-${number}`,
      id: TabsMethods.GetTabId(tabId)
    } : {
      "aria-controls": undefined,
      id: undefined
    };
  },
  ComponentTabStyles = theme => {
    let result;
    try {
      result = {
        fontFamily: "inherit",
        fontSize: "inherit",
        ".tabs-component__tabs-list": {
          borderBottomColor: theme.tabs.desktop.list.borderBottomColor,
          borderBottomStyle: theme.tabs.desktop.list.borderBottomStyle,
          borderBottomWidth: theme.tabs.desktop.list.borderBottomWidth,
          borderRadius: theme.tabs.desktop.list.borderRadius,
          paddingBottom: theme.tabs.desktop.list.paddingBottom,
          paddingLeft: {
            xs: theme.tabs.mobile.list.paddingLeft,
            sm: theme.tabs.tablet.list.paddingLeft,
            md: theme.tabs.desktop.list.paddingLeft
          },
          paddingRight: {
            xs: theme.tabs.mobile.list.paddingRight,
            sm: theme.tabs.tablet.list.paddingRight,
            md: theme.tabs.desktop.list.paddingRight
          },
          paddingTop: theme.tabs.desktop.list.paddingTop,
          ".MuiTabs-indicator": {
            display: theme.tabs.desktop.indicator.display
          },
          ".MuiTabScrollButton-root": {
            width: {
              xs: theme.tabs.mobile.scrollButtons.width,
              sm: theme.tabs.tablet.scrollButtons.width,
              md: theme.tabs.desktop.scrollButtons.width
            }
          },
          ".tabs-component__tab": {
            backgroundColor: theme.tabs.desktop.tab.backgroundColor,
            borderBottomLeftRadius: theme.tabs.desktop.tab.borderBottomLeftRadius,
            borderBottomRightRadius: theme.tabs.desktop.tab.borderBottomRightRadius,
            borderColor: theme.tabs.desktop.tab.borderColor,
            borderTopLeftRadius: theme.tabs.desktop.tab.borderTopLeftRadius,
            borderTopRightRadius: theme.tabs.desktop.tab.borderTopRightRadius,
            borderWidth: theme.tabs.desktop.tab.borderWidth,
            color: theme.tabs.desktop.tab.color,
            fontFamily: theme.tabs.desktop.tab.fontFamily,
            fontSize: theme.tabs.desktop.tab.fontSize,
            marginBottom: theme.tabs.desktop.tab.marginBottom,
            marginLeft: theme.tabs.desktop.tab.marginLeft,
            marginRight: theme.tabs.desktop.tab.marginRight,
            marginTop: theme.tabs.desktop.tab.marginTop,
            paddingBottom: theme.tabs.desktop.tab.paddingBottom,
            paddingLeft: theme.tabs.desktop.tab.paddingLeft,
            paddingRight: theme.tabs.desktop.tab.paddingRight,
            paddingTop: theme.tabs.desktop.tab.paddingTop,
            position: "relative",
            textTransform: theme.tabs.desktop.tab.textTransform,
            "+ .tabs-component__tab": {
              marginLeft: {
                xs: theme.tabs.mobile.tab.marginLeftSubsequent,
                sm: theme.tabs.tablet.tab.marginLeftSubsequent,
                md: theme.tabs.desktop.tab.marginLeftSubsequent
              }
            },
            "&[aria-selected=\"true\"]": {
              backgroundColor: theme.tabs.desktop.tab.selected.backgroundColor,
              borderBottomColor: theme.tabs.desktop.tab.selected.borderBottomColor,
              borderBottomStyle: theme.tabs.desktop.tab.selected.borderBottomStyle,
              borderBottomWidth: theme.tabs.desktop.tab.selected.borderBottomWidth,
              borderRadius: theme.tabs.desktop.tab.selected.borderRadius,
              fontFamily: theme.tabs.desktop.tab.selected.fontFamily,
              textTransform: theme.tabs.desktop.tab.selected.textTransform,
              "&::after": {
                backgroundColor: theme.tabs.desktop.tab.selected.after.backgroundColor,
                bottom: theme.tabs.desktop.tab.selected.after.bottom,
                content: "''",
                display: "block",
                height: theme.tabs.desktop.tab.selected.after.height,
                left: theme.tabs.desktop.tab.selected.after.left,
                position: "absolute",
                width: theme.tabs.desktop.tab.selected.after.width
              }
            },
            ".Mui-focusVisible,&:focus-visible": {
              outline: "none",
              textDecoration: "underline"
            }
          }
        },
        ".tabs-component__tab-panel": {
          paddingBottom: {
            xs: theme.tabs.mobile.panel.paddingBottom,
            sm: theme.tabs.tablet.panel.paddingBottom,
            md: theme.tabs.desktop.panel.paddingBottom
          },
          paddingLeft: {
            xs: theme.tabs.mobile.panel.paddingLeft,
            sm: theme.tabs.tablet.panel.paddingLeft,
            md: theme.tabs.desktop.panel.paddingLeft
          },
          paddingRight: {
            xs: theme.tabs.mobile.panel.paddingRight,
            sm: theme.tabs.tablet.panel.paddingRight,
            md: theme.tabs.desktop.panel.paddingRight
          },
          paddingTop: {
            xs: theme.tabs.mobile.panel.paddingTop,
            sm: theme.tabs.tablet.panel.paddingTop,
            md: theme.tabs.desktop.panel.paddingTop
          }
        }
      };
    } catch (e) {
      result = {};
    }
    return result;
  },
  CustomTabPanel = props => {
    const {
        children,
        className,
        fragmentId,
        customId,
        index,
        isAfterFragment = false,
        instanceString,
        styles = {},
        testId,
        value
      } = props,
      tabId = customId || fragmentId,
      a11yprops = TabsMethods.A11yProps(index, tabId, instanceString),
      isVisible = value === index,
      visibleStyles = isVisible ? {} : {
        display: "none !important"
      },
      compiledStyles = merge(styles, visibleStyles),
      compiledClassnames = (0, _classnames.default)({
        "tabs-component__tab-panel": true,
        [`${className}`]: className
      });
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      "aria-labelledby": a11yprops.id,
      className: compiledClassnames,
      component: "article",
      "data-testid": testId,
      hidden: !isVisible ? "hidden" : undefined,
      id: a11yprops["aria-controls"],
      role: "tabpanel",
      sx: compiledStyles
    }, !isAfterFragment && children && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children), fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
      id: fragmentId
    }), isAfterFragment && children && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children));
  },
  GetIndexFromTab = (tabId, fragmentArray) => {
    let result = -1;
    if ((0, _string.isStringOfLength)(tabId) && (0, _array.isArrayOfLength)(fragmentArray)) {
      result = fragmentArray.findIndex(item => item.customId === tabId || item.fragmentId === tabId);
    }
    return result;
  },
  GetTabId = tabId => {
    let result = "";
    if ((0, _string.isStringOfLength)(tabId)) {
      result = `id_tab-${tabId}`;
    }
    return result;
  },
  GetTestIds = seed => {
    return {
      component: (0, _string.isStringOfLength)(seed) ? seed : undefined,
      tabs: (0, _string.isStringOfLength)(seed) ? `${seed}__tabs` : undefined,
      tabsBlock: (0, _string.isStringOfLength)(seed) ? `${seed}__tabs-block` : undefined
    };
  },
  HandleChange = (newValue, fragmentArray, setter) => {
    let index = null,
      result = false;
    if ((0, _array.isArrayOfLength)(fragmentArray)) {
      if ((0, _string.isStringOfLength)(newValue)) {
        index = TabsMethods.GetIndexFromTab(newValue, fragmentArray);
      } else if ((0, _number.isNumber)(newValue)) {
        index = newValue;
      }
      if (index < 0) {
        index = 0;
      } else if (index > fragmentArray.length - 1) {
        index = fragmentArray.length - 1;
      }
    }
    if ((0, _number.isNumber)(index) && (0, _function.isFunction)(setter)) {
      setter(index);
      result = true;
    }
    return result;
  },
  HandleSetter = (value, setter) => {
    let result = false;
    if ((0, _function.isFunction)(setter)) {
      result = true;
      setter(value);
    }
    return result;
  },
  ProcessSearchValue = (search, fragmentArray, value, setter) => {
    let searchArray,
      requestedTab,
      requestedIndex,
      methodResult = {
        index: -1,
        setterCalled: false
      };
    if ((0, _string.isStringOfLength)(search)) {
      searchArray = search.replace(/^\?/, "").split("&").map(value => {
        const hash = value.split("=");
        let result = false;
        if (hash.length === 2) {
          result = hash[0] === "requestedTabFragment" ? hash[1] : false;
        }
        return result;
      }).filter(value => (0, _string.isStringOfLength)(value));
      requestedTab = (0, _array.isArrayOfLength)(searchArray) && (0, _string.isStringOfLength)(searchArray[0]) ? searchArray[0] : "";
      if ((0, _string.isStringOfLength)(requestedTab)) {
        requestedIndex = TabsMethods.GetIndexFromTab(requestedTab, fragmentArray);
        if (requestedIndex >= 0) {
          methodResult.index = requestedIndex;
          if (value !== requestedIndex && (0, _function.isFunction)(setter)) {
            setter(requestedIndex);
            methodResult.setterCalled = true;
          }
        }
      }
    }
    return methodResult;
  };

/**
 * Internal Template for generating new components
 *
 * @visibleName Tabs
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
 * * @example
 * Link opens a targeted tab through url query search value of fragment id:
 * <pre>&lt;a href=&quot;location?requestedTabFragment={fragmentId}&quot;&gt;Link&lt;/a&gt;</pre>
*/
exports.ProcessSearchValue = ProcessSearchValue;
exports.HandleSetter = HandleSetter;
exports.HandleChange = HandleChange;
exports.GetTestIds = GetTestIds;
exports.GetTabId = GetTabId;
exports.GetIndexFromTab = GetIndexFromTab;
exports.CustomTabPanel = CustomTabPanel;
exports.ComponentTabStyles = ComponentTabStyles;
exports.A11yProps = A11yProps;
const Tabs = props => {
  const {
      className,
      customInstanceString,
      customTheme = {},
      defaultFocusId,
      fragmentArray,
      scrollButtons,
      openFragment,
      openIndex,
      styles = {},
      tabStyles = {},
      testId
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    componentClasses = (0, _classnames.default)({
      "tabs-component": true,
      [`${className}`]: (0, _string.isStringOfLength)(className)
    }),
    compiledStyles = merge({
      fontFamily: "inherit",
      fontSize: "inherit",
      margin: {
        xs: `${theme.contentSpacing.mobileInterior} 0`,
        md: `${theme.contentSpacing.desktopInterior} 0`
      }
    }, styles),
    compiledTabStyles = merge.all([{
      fontFamily: "inherit",
      fontSize: "inherit"
    }, ComponentTabStyles(theme), tabStyles]),
    location = (0, _reactRouterDom.useLocation)(),
    [value, setValue] = (0, _react.useState)(0),
    [focusId, setFocusId] = (0, _react.useState)(defaultFocusId),
    testIds = TabsMethods.GetTestIds(testId),
    tabInstanceString = (0, _react.useRef)((0, _string.isStringOfLength)(customInstanceString) ? customInstanceString : "tabInstanceString"),
    tabsRef = (0, _react.useRef)(null),
    // ref on box surrounding tabs for desktop scrolling
    isDesktop = (0, _useMediaQuery.default)(`(min-width:${theme.breakpoints.values.md}${theme.breakpoints.unit}`),
    handleChange = (event, newValue) => TabsMethods.HandleChange(newValue, fragmentArray, setValue);
  (0, _react.useEffect)(() => {
    const fragmentIndex = TabsMethods.GetIndexFromTab(openFragment, fragmentArray),
      fragmentArg = fragmentIndex > 0 && fragmentIndex < fragmentArray.length ? fragmentIndex : 0;

    // checking for an openIndex property to autopen the tabs, passed in by developer!
    if ((0, _number.isNumber)(openIndex) && openIndex > 0 && openIndex < fragmentArray.length) {
      TabsMethods.HandleSetter(openIndex, setValue);
      TabsMethods.HandleSetter(fragmentArray[openIndex].fragmentId, setFocusId);
      // checking for default openFragment prop to open the tabs, passed in by developer!
    } else if ((0, _string.isStringOfLength)(openFragment)) {
      TabsMethods.HandleSetter(fragmentArg, setValue);
      TabsMethods.HandleSetter(openFragment, setFocusId);
    } else {
      // checking location.search to get tab to open and focus
      const {
        index
      } = TabsMethods.ProcessSearchValue(location.search, fragmentArray, value, setValue, isDesktop);
      const tabToFocusOn = fragmentArray[index]?.customId || fragmentArray[index]?.fragmentId;
      if (index > -1) {
        TabsMethods.HandleSetter(tabToFocusOn, setFocusId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, openFragment, openIndex]);
  (0, _react.useLayoutEffect)(() => {
    // find element to scroll to and focus to
    let focusElement;
    let scrollElement;
    if ((0, _string.isStringOfLength)(focusId)) {
      scrollElement = tabsRef.current;
      focusElement = document.querySelector(`#${TabsMethods.GetTabId(focusId)}`);
      if (focusElement) {
        setFocusId(null);
        setTimeout(() => {
          ScrollMethods.moveFocus(focusElement, {
            preventScroll: true
          });
          ScrollMethods.scrollToElement(scrollElement, {
            disableMoveFocus: true
          });
        }, 500);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusId]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: componentClasses,
    component: "section",
    "data-testid": testIds.component,
    sx: compiledStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    ref: tabsRef,
    className: "tabs-component__tabs-block",
    sx: compiledTabStyles,
    "data-testid": testIds.tabsBlock
  }, /*#__PURE__*/_react.default.createElement(_material.Tabs, {
    className: "tabs-component__tabs-list",
    "data-testid": testIds.tabs,
    onChange: handleChange,
    scrollButtons: scrollButtons,
    allowScrollButtonsMobile: true,
    value: value,
    variant: "scrollable"
  }, fragmentArray.map((item, index) => {
    const tabId = item.customId || item.fragmentId;
    return /*#__PURE__*/_react.default.createElement(_material.Tab, _extends({
      className: "tabs-component__tab",
      "data-tab-id": tabId,
      disableRipple: true,
      key: `${tabId}__tab`,
      label: item.label
    }, TabsMethods.A11yProps(index, tabId, tabInstanceString.current)));
  })), fragmentArray.map((item, index) => {
    const {
      className,
      children,
      customId,
      isAfterFragment,
      fragmentId,
      styles
    } = item;
    const tabId = item.customId || item.fragmentId;
    return /*#__PURE__*/_react.default.createElement(CustomTabPanel, {
      className: className,
      children: children,
      customId: customId,
      fragmentId: fragmentId,
      index: index,
      isAfterFragment: isAfterFragment,
      key: `${tabId}__tab-panel`,
      instanceString: tabInstanceString.current,
      styles: styles,
      value: value
    });
  })));
};
CustomTabPanel.propTypes = {
  /** Children node(s) to include in content */
  children: _propTypes.default.any,
  /** Class name(s) to include on each panel */
  className: _propTypes.default.string,
  /** Fragment ID of base content */
  fragmentId: _propTypes.default.string,
  /** Boolean to move children position after the fragment  */
  isCustom: _propTypes.default.bool,
  /** Boolean to move children position after the fragment  */
  isAfterFragment: _propTypes.default.bool,
  /** Styles object */
  styles: _propTypes.default.object
};

// Define propTypes;
Tabs.propTypes = {
  /** Custom class name(s) to apply to parent component */
  className: _propTypes.default.string,
  /** @ignore */
  customInstanceString: _propTypes.default.string,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** @ignore */
  defaultFocusId: _propTypes.default.any,
  /** @ignore */
  /** Array of fragments data */
  fragmentArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Children node(s) to include in content */
    children: _propTypes.default.any,
    /** Class name(s) to include on each panel */
    className: _propTypes.default.string,
    /** Custom ID of custom content */
    customId: _propTypes.default.string,
    /** Fragment ID of base content */
    fragmentId: _propTypes.default.string,
    /** Boolean to move children position after the fragment  */
    isAfterFragment: _propTypes.default.bool,
    /** Label of open/hide button */
    label: _propTypes.default.string.isRequired,
    /** Styles object */
    styles: _propTypes.default.object
  })).isRequired,
  /** Boolean to activate automatic scroll controls */
  scrollButtons: _propTypes.default.oneOf([true, false, "auto"]),
  /** Fragment ID to open on load */
  openFragment: _propTypes.default.string,
  /** Index of open tab on load */
  openIndex: _propTypes.default.number,
  /** Custom style object for entire component (Default Value: {}) */
  styles: _propTypes.default.object,
  /** Custom style object for changing desktop tabs appearance (Default Value: {}) */
  tabStyles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = Tabs;